import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  TableContainer,
  TablePagination,
  TextField,
  Pagination,
} from "@mui/material";
import Indexdasboard from "../../components/dashboard/IndexDashbord";
import { Api_Token } from "../../util/Api";
//import CreditCardIcon from "@mui/icons-material/CreditCard"; // Icon
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import NoteIcon from "@mui/icons-material/Note";
import SystemSecurityUpdateGoodIcon from "@mui/icons-material/SystemSecurityUpdateGood";
import TitreGraphik from "../../components/Typography/TitreGraphik";
//import LabelTypography from "../../components/Typography/LabelTypography";
import { useTranslation } from "react-i18next";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import BookingsTransactionPayment from "../../components/BookingTransaction/BookingsTransactionPayment";


function PagedashboardUser() {
  return <Indexdasboard Children={<DashboardUser />} />;
}

function DashboardUser() {
  const [statistics, setStatistics] = useState([]);
  const [Paiments, SetPaiments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [date, setData] = useState(null);
  const { t } = useTranslation();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Fetch data from the API
  useEffect(() => {
    const filter = date ? `?date=${date}` : "";
    Api_Token.get(`statistique/getStatistiquedUser${filter}`)
      .then((response) => {
        setStatistics(response.data);
      })
      .catch((error) => {
        console.error("Error fetching statistics:", error);
      });
  }, [date]);

  const fetchChecks = useCallback(async (currentPage, rowsPerPage, date) => {
    try {
      const filter = date ? `&date=${date}` : "";
      const response = await Api_Token.get(
        `statistique/getListBookingsByDateUser?page=${
          currentPage + 1
        }&perPage=${rowsPerPage}${filter}`
      );
      SetPaiments(response.data.data);
      setTotalCount(response.data.total);
    } catch (error) {
      console.error("Error fetching checks:", error);
    }
  }, []);

  useEffect(() => {
    fetchChecks(page, rowsPerPage, date);
  }, [fetchChecks, page, rowsPerPage, date]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CardStatiquepayment statistics={statistics} />
        </Grid>
        <Grid item xs={12} sx={{ display: { xs: "none", md: "flex" } }}>
          <Card sx={{ padding: "2%", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TitreGraphik>{t("List Bookings")}</TitreGraphik>
              <TextField
                type="date"
                value={date}
                onChange={(e) => setData(e.target.value)}
              />
            </Box>
            <TableContainer sx={{ marginTop: "20px" }}>
              <BookingsTransactionPayment
                bookings={Paiments}
                listAffiche={[
                  "idBookings",
                  "idTransaction",
                  "Montant",
                  "payment method",
                ]}
              />
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Card>
        </Grid>
        <Grid item xs={12} sx={{ display: { xs: "flex", md: "none" } }}>
          <Box sx={{ width: "100%" }}>
            <TitreGraphik>{t("List Bookings")}</TitreGraphik>
            <Card sx={{ marginTop: "3%" }}>
              <TextField
                type="date"
                value={date}
                onChange={(e) => setData(e.target.value)}
                fullWidth
              />
            </Card>
            <Box sx={{ marginTop: "3%" }}>
              <BookingsTransactionPayment
                bookings={Paiments}
                listAffiche={[
                  "idBookings",
                  "idTransaction",
                  "Montant",
                  "payment method",
                ]}
              />
            </Box>
            <Box
              sx={{
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Pagination
                count={Math.ceil(totalCount / rowsPerPage)}
                onChange={(event, newPage) => {
                  setPage(newPage - 1); // Adjust for 0-based indexing
                }}
                variant="outlined"
                color="primary"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export function CardStatiquepayment({ statistics }) {
  const { t } = useTranslation();
  const cash = statistics.find((p) => p.payment_method === "cash") || {
    total_amount: 0,
    total_transactions: 0,
  };
  const check = statistics.find((p) => p.payment_method === "check") || {
    total_amount: 0,
    total_transactions: 0,
  };
  const virements = statistics.find(
    (p) => p.payment_method === "virements"
  ) || { total_amount: 0, total_transactions: 0 };

  const Cart = statistics.find((p) => p.payment_method === "cart") || {
    total_amount: 0,
    total_transactions: 0,
  };

  return (
    <Grid container spacing={2}>
      {/* Total Card */}
      <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <PointOfSaleIcon style={{ fontSize: 40 }} />
            <Typography variant="h6" component="div">
              {t("Total Amount")}
            </Typography>
            <Typography variant="h4">
              <NumericFormatEnv
                Number={
                  parseFloat(cash.total_amount) +
                  parseFloat(check.total_amount) +
                  parseFloat(virements.total_amount) +
                  parseFloat(Cart.total_amount)
                }
              />
            </Typography>
            <Typography variant="body1">
              {parseFloat(cash.total_transactions) +
                parseFloat(check.total_transactions) +
                parseFloat(virements.total_transactions) +
                parseFloat(Cart.total_transactions)}{" "}
              {t("Transactions")}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      {/* Cash Payment Card */}
      <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <AttachMoneyIcon style={{ fontSize: 40 }} />
            <Typography variant="h6" component="div">
              {t("Cash")}
            </Typography>
            <Typography variant="h4">
              <NumericFormatEnv Number={cash.total_amount} />
            </Typography>
            <Typography variant="body1">
              {cash.total_transactions} {t("Transactions")}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <AttachMoneyIcon style={{ fontSize: 40 }} />
            <Typography variant="h6" component="div">
              {t("Cart")}
            </Typography>
            <Typography variant="h4">
              <NumericFormatEnv Number={Cart.total_amount} />
            </Typography>
            <Typography variant="body1">
              {Cart.total_transactions} {t("Transactions")}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      {/* Check Payment Card */}
      <Grid item xs={12} md={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={3}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <NoteIcon style={{ fontSize: 40 }} />
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="h6" component="div">
                    {t("Check")}
                  </Typography>
                  <Typography>
                    <NumericFormatEnv Number={check.total_amount} />
                  </Typography>
                  <Typography variant="body1">
                    {check.total_transactions} {t("Transactions")}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          {/* Virements Payment Card */}
          <Grid item xs={12}>
            <Card>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={3}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <SystemSecurityUpdateGoodIcon style={{ fontSize: 40 }} />
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="h6" component="div">
                    {t("Virement")}
                  </Typography>
                  <Typography>
                    <NumericFormatEnv Number={virements.total_amount} />
                  </Typography>
                  <Typography variant="body1">
                    {virements.total_transactions} {t("Transactions")}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PagedashboardUser;
